// extracted by mini-css-extract-plugin
module.exports = {"root":"BackToOverview-module__root--3J4Hl","icon":"BackToOverview-module__icon--2UO0x"};